export default "__VITE_ASSET__$ag0527R__"